import { render, staticRenderFns } from "./TextMessagesDialog.vue?vue&type=template&id=4af1b063&"
import script from "./TextMessagesDialog.vue?vue&type=script&lang=js&"
export * from "./TextMessagesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports